import React from "react"
import {FieldInlineEditableProps} from "../../../../render/inline-editable";
import FieldToggle_ComponentStatefull from "../components/toggle-statefull";

export default function FieldToggle_InlineEditable(props: FieldInlineEditableProps) {

    const value = props.model[props.field.fieldId]

    return <FieldToggle_ComponentStatefull field={props.field} value={value} onChange={props.onChange} />

}

